//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IRightsPermissions } from '@models/IItemMetadata';
import { Serialized } from '@utils/types/Serialized';

export const deserializeRightsPermissions = (
  permissions: Serialized<IRightsPermissions> | undefined,
): IRightsPermissions => ({
  ...permissions,
  expirationTime: permissions?.expirationTime
    ? new Date(permissions.expirationTime)
    : undefined,
});
